import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
export default function isIterable(a) {
  return a != null && !!_getIteratorMethod(a);
}